/* eslint-disable react/jsx-key */
import { UIText1, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './tourSlider.css';

export interface ITourComponentProps {
  tourBannerImageUrl: string;
  onClick: () => void;
}

export const TourSlide = ({ onClick, tourBannerImageUrl }: ITourComponentProps) => {
  return (
    <div className={styles['tour']} id="tourBlock">
      <div className={styles['content']}>
        <div
          className={styles['layout']}
          style={{ backgroundImage: `url(${tourBannerImageUrl})` }}
          data-tour="layout"
          data-testid="tour"
          onClick={onClick}
        >
          <div className={styles['text']}>
            <UIText1 userSelect="none" color="white_100">
              Погуляйте по комнатам, чтобы оценить планировку.
            </UIText1>
            <UIText1 userSelect="none" color="white_100">
              Мебель использована для примера.
            </UIText1>
          </div>
          <Button onClick={onClick} theme="fill_white_primary" size="XS">
            Погулять по квартире
          </Button>
        </div>
      </div>
    </div>
  );
};

TourSlide.displayName = 'TourComponent';
